import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './EditGuardian.css';
import PageHeader from './PageHeader';
import { AxiosPut } from '../http/Axios';

const EditGuardian = (props) => {
  const [errors, setErrors] = useState({});
  const [phone, setPhone] = useState('');

  const loggedInAs = sessionStorage.getItem("loggedInAs") || "admin";

  useEffect(() => {
    document.title = 'LeapFrog Lab Registration Admin Portal';
  }, []);

  const location = useLocation();
  const navigate = useNavigate();


  const {
    guid,
    familyEmail,
    guardianId,
    guardianData: initialGuardianData,
    familyName,
  } = location.state || {};

  console.log(guid);
  console.log(familyEmail);
  console.log(guardianId);

  const [guardianData, setGuardianData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    primaryPhone: '',
    relationshipToChild: '',
    isPrimaryIndicator: '',
    zipCode: '',
    familyEmail: '',
    notes: '',
  });

  useEffect(() => {
    if (initialGuardianData) {
      setGuardianData({
        firstName: initialGuardianData.firstName || '',
        lastName: initialGuardianData.lastName || '',
        email: initialGuardianData.email || familyEmail,
        primaryPhone: initialGuardianData.primaryPhone || '',
        relationshipToChild: initialGuardianData.relationshipToChild || '',
        isPrimaryIndicator: initialGuardianData.isPrimaryIndicator || '',
        zipCode: initialGuardianData.zipCode || '',
        familyEmail: initialGuardianData.familyEmail,
        notes: initialGuardianData.notes || '',
      });
    }
  }, [initialGuardianData, familyEmail]);

  const formatPhoneNumber = (value) => {
    // Remove all non-digit characters
    const cleaned = ('' + value).replace(/\D/g, '');
    // Check if the cleaned string has at least 10 digits
    if (cleaned.length >= 10) {
      // Format the phone number as (xxx) xxx-xxxx
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
    }
    return cleaned;
  };

  const handlePhoneChange = (event) => {
    const formattedPhone = formatPhoneNumber(event.target.value);
    setPhone(formattedPhone);
    setGuardianData((prevData) => ({
      ...prevData,
      primaryPhone: formattedPhone,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const guardianPostData = {
      firstName: guardianData.firstName,
      lastName: guardianData.lastName,
      email: guardianData.email,
      primaryPhone: guardianData.primaryPhone,
      relationshipToChild: guardianData.relationshipToChild,
      isPrimaryIndicator: guardianData.isPrimaryIndicator,
      zipCode: guardianData.zipCode,
      familyEmail: guardianData.familyEmail,
      notes: guardianData.notes,
      modifiedDate: new Date(),
      modifiedBy: loggedInAs,
    };

    try {
      const response = await AxiosPut(
        process.env.REACT_APP_ADMIN_SERVICE + `/guardians/${guardianId}`,
        guardianPostData
      );
      console.log('Guardian data updated successfully:', response.data);

      const familyDetailsPath = '/family-details-page';
      navigate(
        `${familyDetailsPath}?guid=${guid}`
      );
    } catch (error) {
      console.error('Error submitting guardian data:', error);
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setGuardianData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleCancel = () => {
    const familyDetailsPath = '/family-details-page';
    navigate(
      `${familyDetailsPath}?guid=${guid}`
    );
  };

  return (
    <div className="dashboard landing-page">
      <PageHeader title={familyName ? `The ${familyName} Family: Edit Guardian` : "Edit Guardian"} />

      <main className="page-content">
        <form onSubmit={handleSubmit}>
          <div className="guardian-section">
            <br />
            <br />
            <div className="guardian-input-grid">

              <div className="guardian-input-group">
                <label htmlFor="firstName">
                  First name <span style={{ color: 'red' }}>*</span>
                </label>
                <input
                  type="text"
                  name="firstName"
                  value={guardianData.firstName}
                  onChange={handleInputChange}
                  required
                  maxLength="31"
                  pattern="[a-zA-Z .'-]+"
                  title="Guardian first name should only contain letters, period, apostrophe, hyphen/dash/em-dash, quotes, and spaces."
                  className="guardian-input-size"
                />
                {errors.firstName && (
                  <p className="error-message">{errors.firstName}</p>
                )}
              </div>

              <div className="guardian-input-group">
                <label htmlFor="lastName">
                  Last name <span style={{ color: 'red' }}>*</span>
                </label>
                <input
                  type="text"
                  name="lastName"
                  value={guardianData.lastName}
                  onChange={handleInputChange}
                  required
                  maxLength="31"
                  pattern="[a-zA-Z .'-]+"
                  title="Guardian last name should only contain letters, period, apostrophe, hyphen/dash/em-dash, quotes, and spaces."
                  className="guardian-input-size"
                />
                {errors.lastName && (
                  <p className="error-message">{errors.lastName}</p>
                )}
              </div>

              <div className="guardian-input-group">
                <label htmlFor="guardianEmail">
                  Email <span style={{ color: 'red' }}>*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  value={guardianData.email}
                  onChange={handleInputChange}
                  required
                  maxLength="99"
                  pattern="^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                  title="Email should contain uppercase and lowercase Latin letters A to Z, digits 0 to 9, and printable characters !#$%&'*+-/=?^_`{|}~. It should not start or end with a dot or have consecutive dots."
                  className="guardian-input-size"
                />
                {errors.email && (
                  <p className="error-message">{errors.email}</p>
                )}
              </div>

              <div className="guardian-input-group">
                <label htmlFor="zipCode">
                  Zip code <span style={{ color: 'red' }}>*</span>
                </label>
                <input
                  type="text"
                  name="zipCode"
                  value={guardianData.zipCode}
                  onChange={handleInputChange}
                  required
                  maxLength="5"
                  placeholder="#####"
                  pattern="\d{5}"
                  title="Zip Code should contain 5 digits only."
                  className="guardian-input-size"
                />
                {errors.zipCode && (
                  <p className="error-message">{errors.zipCode}</p>
                )}
              </div>

              <div className="guardian-input-group">
                <label htmlFor="primaryPhone">
                  Primary phone <span style={{ color: 'red' }}>*</span>
                </label>
                <input
                  type="text"
                  name="primaryPhone"
                  value={guardianData.primaryPhone}
                  onChange={handlePhoneChange}
                  required
                  maxLength="14"
                  placeholder="(###) ###-####"
                  pattern="\(\d{3}\) \d{3}-\d{4}"
                  title="Primary phone number must be in the format: (123) 456-7890."
                  className="guardian-input-size"
                />
                {errors.primaryPhone && (
                  <p className="error-message">{errors.primaryPhone}</p>
                )}
              </div>

              <div className="guardian-input-group">
                <label htmlFor="relationshipToChild">
                  Relationship to child <span style={{ color: 'red' }}>*</span>
                </label>
                <select
                  name="relationshipToChild"
                  value={guardianData.relationshipToChild}
                  onChange={handleInputChange}
                  required
                  className="guardian-input-size"
                >
                  <option value="">Select Relationship</option>
                  <option value="Mother">Mother</option>
                  <option value="Father">Father</option>
                  <option value="Grandmother">Grandmother</option>
                  <option value="Grandfather">Grandfather</option>
                  <option value="Sibling">Sibling</option>
                  <option value="Cousin">Cousin</option>
                  <option value="Stepmother">Stepmother</option>
                  <option value="Stepfather">Stepfather</option>
                  <option value="Aunt">Aunt</option>
                  <option value="Uncle">Uncle</option>
                  <option value="Nanny">Nanny</option>
                  <option value="Foster Mother">Foster Mother</option>
                  <option value="Foster Father">Foster Father</option>
                  <option value="Guardian">Guardian</option>
                  <option value="Other">Other</option>
                </select>
                {errors.relationshipToChild && (
                  <p className="error-message">{errors.relationshipToChild}</p>
                )}
              </div>

              <div className="guardian-input-group">
                <label htmlFor="isPrimaryIndicator">
                  Is primary? <span style={{ color: 'red' }}>*</span>
                </label>
                <select
                  name="isPrimaryIndicator"
                  value={guardianData.isPrimaryIndicator}
                  onChange={handleInputChange}
                  required
                  className="guardian-input-size"
                >
                  <option value="">Select One</option>
                  <option value="Y">Y</option>
                  <option value="N">N</option>
                </select>
                {errors.isPrimaryIndicator && (
                  <p className="error-message">{errors.isPrimaryIndicator}</p>
                )}
              </div>

              <div className="guardian-input-group">
                <label htmlFor="notes">Notes</label>
                <textarea
                  name="notes"
                  value={guardianData.notes}
                  onChange={handleInputChange}
                  maxLength="1024"
                  placeholder=""
                  className="guardian-input-size"
                  rows="3"
                />
                {errors.notes && <p className="error-message">{errors.notes}</p>}
              </div>

              <div className="button-group">
                <button type="submit" className="submit-button">
                  Submit
                </button>
                <button
                  type="button"
                  className="cancel-button"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </form>
      </main>
    </div>
  );
};

export default EditGuardian;
